import { render, staticRenderFns } from "./price-check-page.vue?vue&type=template&id=403f837f&scoped=true"
import script from "./price-check-page.vue?vue&type=script&lang=js"
export * from "./price-check-page.vue?vue&type=script&lang=js"
import style0 from "./price-check-page.vue?vue&type=style&index=0&id=403f837f&prod&lang=css"
import style1 from "./price-check-page.vue?vue&type=style&index=1&id=403f837f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403f837f",
  null
  
)

export default component.exports